import React from "react";
import $ from "jquery";
import Page from "../Page";
import {
	CheckAuth,
	API_BASE_URL,
	API_BANK_NAME,
	API_DETAIL_PROFILE,
	API_PASSWORD_FORGET
} from "../Util";
import {
	Row,
	Col,
	Icon,
	Modal,
	Button,
} from "react-materialize";
import { notify } from "react-notify-toast";
import "../../styles/personal-data.css";
import { alert } from "../Lang";

class UploadVerifData extends Page {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
			banksData: [],
			formData: {
				bank_id: '',
				bank_accountnumber: '',
				bank_accountname: '',
				file_ktp: '',
				urlKTP: '',
				urlNpwp: '',
				file_npwp: ''
			},
			formErrors: {
				errorBank_id: '',
				errorBank_accountnumber: '',
				errorBank_accountname: '',
				errorFile_ktp: '',
				errorUrlKTP: '',
				errorUrlNpwp: '',
				errorFile_npwp: ''
			}
		};

		this.regexPassword = RegExp(/^(?=.*\d)(?=.*[a-zA-Z]).*$/);
	}

	componentDidMount() {
		this.handleLoadData();
		this.handleLoadBank();
	}

	handleLoadData = () => {
		/*$.post(API_BASE_URL + '').then(data => {
			this.setState({ data: data.payload.data[0] });
		});*/
	};

	handleLoadBank(){
		$.get(API_BANK_NAME).then( data => {
			this.setState({ banksData : data.payload});
			console.log('cek bank', this.state.banksData);
		})
	}

	handleChange = e => {
		
		let { value, name } = e.target;
		let { formData } = this.state;

		switch (name) {
			case "bank_id":
				formData.bank_id = value;
				break;
			case "bank_accountnumber":
				formData.bank_accountnumber = value;
				break;
			case "bank_accountname":
				formData.bank_accountname = value;
				break;
		}

		this.setState({ formData });
	};

	checkIsFormValid = () => {
		let formData = this.state.formData
		let { formErrors } = this.state;
		let isValid = true;

		if(!formData.bank_id) {
			formErrors.errorBank_id = "Nama bank tidak boleh kosong"
		}else{
			formErrors.errorBank_id = ""
		}

		if(!formData.bank_accountnumber) {
			formErrors.errorBank_accountnumber = "Nomor rekening bank tidak boleh kosong"
		}else if(!formData.bank_accountnumber.match(/^\d+$/)) {
			formErrors.errorBank_accountnumber = 'Nomor rekening hanya boleh terdiri dari angka'
		}else{
			formErrors.errorBank_accountnumber = ''
		}

		if(!formData.bank_accountname) {
			formErrors.errorBank_accountname = "Nama pemilik rekening bank tidak boleh kosong"
		}else{
			formErrors.errorBank_accountname = ""
		}

		if(!formData.file_ktp) {
			formErrors.errorFile_ktp = "Kolom KTP tidak boleh kosong"
		}else{
			formErrors.errorFile_ktp = ""	
		}

		this.setState({ formErrors });

		// RETURN ISVALID
		Object.values(formErrors).forEach(value => {
			if (value) {
				this.setState;
				isValid = false;
			}
		});
		// console.log('cek verif ktp');
		return isValid;
	};

	//when click submit button
	handleClickSubmit = async e => {
		e.preventDefault();
		if (this.checkIsFormValid()) {
			let { bank_id, bank_accountname, bank_accountnumber, file_ktp, file_npwp } = this.state.formData;
			let dataUploadVerif;

			dataUploadVerif = {
				bank_id: bank_id,
				bank_accountname: bank_accountname,
				bank_accountnumber: bank_accountnumber,
				file_ktp: file_ktp,
				file_npwp: file_npwp
			};
		}
		this.handleSubmitData();

	};

	//when form data is valid
	handleSubmitData = (dataUploadVerif) => {
		
		let formData = new FormData($("#form-upload")[0]);

		$.ajax({
			url: API_BASE_URL + "/submit_ktp" ,
			data: formData,
			type: 'POST',
			contentType: false, // NEEDED, DON'T OMIT THIS (requires jQuery 1.6+)
			processData: false, // NEEDED, DON'T OMIT THIS
			// ... Other options like success and etc
		}).then((data) => {
			console.log('cek upload ktp', data);
			if (data.status === true) {
				notify.show(
					"Terima kasih sudah melakukan verifikasi.",
					"success"
				);
				this.props.history.push("/detail-benefit");
			} else {
				notify.show("Terdapat kesalahan, silakan coba lagi", "warning");
			}
		});
	};

	resetForm = () => {
		this.setState({
			formData: {
			},
			formErrors: {
			}
		})
	}

	//upload KTP
	handleUploadKtp = (e) => {
		let file = e.target.files;
		let { formData } = this.state;
		
		if (file[0].type.indexOf("image") === -1) {
			notify.show("File harus berupa gambar", "warning");
			e.target.value = '';
			return;
		}
		
		const url = URL.createObjectURL(file[0]);
		formData.file_ktp = e.target.value;
		this.setState({ formData, urlKTP : url });
	}

	//upload NPWP
	handleUploadNpwp = (e) => {
		var file = e.target.files;
		let { formData } = this.state;

		if (file[0].type.indexOf("image") === -1) {
			notify.show("File harus berupa gambar", "warning");
			e.target.value = '';
			return;
		}

		const url = URL.createObjectURL(file[0]);
		formData.file_npwp = e.target.value;
		this.setState({ formData, urlNpwp : url });
	}

	render() {
		let { data, formErrors, formData, banksData, urlKTP, urlNpwp } = this.state;

		//console.info(formData);
		/*if (!data) {
			return super.render();
		}*/

		return (

			<div className="bg-white no-shadow container pad-m">
				<Row>
					<Col s={12} m={12} l={12}>
						<h5>Verifikasi Data</h5>
					</Col>
				</Row>
				<hr />
				<div>
					<form id="form-upload">
						<InputSelect
							label="Nama Bank"
							name="bank_id"
							type="text"
							placeholder="Pilih Nama Bank"
							value={formData.bank_id}
							onChange={this.handleChange}
							banksData={banksData}
							formErrors={formErrors}
						/>
						<InputField
							label="Nomor Rekening"
							name="bank_accountnumber"
							type="text"
							placeholder="Masukkan Nomor Rekening"
							value={formData.bank_accountnumber}
							onChange={this.handleChange}
							formErrors={formErrors}
						/>
						<InputField
							label="Nama Pemilik Rekening"
							name="bank_accountname"
							type="text"
							placeholder="Masukkan Pemilik Rekening"
							value={formData.bank_accountname}
							onChange={this.handleChange}
							formErrors={formErrors}
						/>
						<UploadButton
							label="Foto KTP"
							name="file_ktp"
							type="file"
							placeholder="Upload File KTP"
							handleUpload={this.handleUploadKtp}
							urlKTP={urlKTP}
							formErrors={formErrors}
						/>
						<UploadButton
							label="Foto NPWP"
							name="file_npwp"
							type="file"
							placeholder="Upload File NPWP"
							handleUpload={this.handleUploadNpwp}
							urlNpwp={urlNpwp}
							formErrors={formErrors}
						/>

						<Row className="mt-m">
							<Col s={2} m={2} l={2}>
								<Button className="btn-small" onClick={this.handleClickSubmit}>
									Simpan
								</Button>
							</Col>
						</Row>
					</form>
				</div>
			</div>

		);
	}
}

export default UploadVerifData;

class InputSelect extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<Row>
				<Col s={3} m={2} l={2}>
					<p>{this.props.label}&nbsp;</p>
				</Col>
				<Col s={9} m={5} l={5} className="list-data">
						<select
							name={this.props.name}
							className="drop-down mb-0"
							// placeholder={this.props.placeholder}
							// type={this.props.type}
							onChange={this.props.onChange}
							value={this.props.value}
						>
							<option value="" disabled >Pilih Bank</option>
								{
									this.props.banksData.map((item) => (
										<option value={item.id}>{item.name}</option>
									))
								}
						</select>
						<div style={{ color:'red' }} className="helper-text font-orange-red inline-block font-tiny">
							{this.props.formErrors.errorBank_id}
						</div>
				</Col>
			</Row>)
	}
}


class InputField extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<Row>
				<Col s={3} m={2} l={2}>
					<p>{this.props.label}&nbsp;</p>
				</Col>
				<Col s={9} m={5} l={5} className="list-data">
					<input
						className="mb-0"
						name={this.props.name}
						placeholder={this.props.placeholder}
						type={this.props.type}
						onChange={this.props.onChange}
						value={this.props.value}
					/>
					{
						this.props.name == 'bank_accountname' ?
							<div style={{ color:'red' }} className="helper-text font-orange-red inline-block font-tiny">
								{this.props.formErrors.errorBank_accountname}
							</div>
						:
							<div style={{ color:'red' }} className="helper-text font-orange-red inline-block font-tiny">
								{this.props.formErrors.errorBank_accountnumber}
							</div>

					}
				</Col>
			</Row>)
	}
}



class UploadButton extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const divStyle = {
			display: "none"
		};

		return (
			<Row>
				<Col s={3} m={2} l={2}>
					<p>{this.props.label}&nbsp;</p>
				</Col>
				<Col s={9} m={5} l={5} className="list-data">
					<div className="mb-xss">
						<label>
							<input 
								className="mb-0"
								style={divStyle}
								name={this.props.name}
								onChange={this.props.handleUpload}
								type="file"
							/>
							{
								this.props.name == 'file_ktp' ? 
									<img src={this.props.urlKTP} />
								:
									<img src={this.props.urlNpwp} />
							}
							<span className="btn capitalize btn-small">{this.props.placeholder}</span>
						</label>
						{
							this.props.name == 'file_ktp' ?
							<div style={{ color:'red' }} className="helper-text font-orange-red inline-block font-tiny">
								{this.props.formErrors.errorFile_ktp}
							</div>
						:
							''
						}
					</div>
				</Col>
			</Row>)
	}
}



// WEBPACK FOOTER //
// ./src/components/Referral/UploadVerifData.js